import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=08b0e73f"
import script from "./customerDetail.vue?vue&type=script&lang=js"
export * from "./customerDetail.vue?vue&type=script&lang=js"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=08b0e73f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports